import type { ReactNode } from 'react';
import { Pagination } from '../../shared/ui/pagination';

export type PaginatedContentProps = {
  pageNumber: number;
  pageSize: number;
  totalCount: number;
  onPageChange: (page: number) => void;
  isLoading?: boolean;
  children: ReactNode;
  className?: string;
  classNamePagination?: string;
};

export const PaginatedContent = ({
  pageNumber,
  pageSize,
  totalCount,
  onPageChange,
  isLoading = false,
  children,
  className = '',
  classNamePagination,
}: PaginatedContentProps) => {
  return (
    <div className={`flex flex-col gap-4 ${className}`}>
      {children}
      <Pagination
        pageNumber={pageNumber}
        pageSize={pageSize}
        totalCount={totalCount}
        onPageChange={onPageChange}
        isLoading={isLoading}
        className={classNamePagination}
      />
    </div>
  );
};
